import React from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { Control, Divider } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import validate from '@vlabs/shared/validators';
import { generatePath, useHistory } from 'react-router-dom';
import { DefaultCaption } from './DropzoneCaption';
import { routes } from '@vlabs/shared/navigation/routes';
import { SUPPORTED_AUDIO_MIME, SUPPORTED_VIDEO_MIME, BYTES_MAX_SIZE } from './constants';
import st from './VideoAndAudioForm.module.sass';

type FormValues = {
  file: FileList | undefined;
};

type FormProps = {
  onCloseModal: () => void;
};

// ВРЕМЕННЫЙ тип для lunaClient (заменить на реальные из @vlabs/api-bindings при появлении)
type LunaClientShim = {
  objects: {
    create(file: File, config: object): Promise<{ data: { external_url: string } }>;
  };
};

const VideoAndAudioForm: React.FC<FormProps> = ({ onCloseModal }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const form = useForm<FormValues>({ defaultValues: { file: undefined } });

  const onSubmit = async (values: FormValues) => {
    const fileList = values.file;
    const firstFile = fileList?.[0];
    if (!firstFile) return;
    onCloseModal();

    const lunaClient = (apiContainer as unknown as { lunaClient: LunaClientShim }).lunaClient;
    const { data } = await lunaClient.objects.create(firstFile,
      {
        headers: {
          'Content-type': firstFile.type,
          'X-Luna-Meta-Filename': firstFile.name,
        }
      }
    );
    const { external_url } = data;
    const url = `${generatePath(routes.checks.videoAndAudioResults)}?file_url=${encodeURIComponent(external_url)}`;
    history.push(url);
  };

  return (
    <form className={st.FormWrapper} onSubmit={form.handleSubmit(onSubmit)}>
      <h5>{t('checks:check video audio.title')}</h5>
      <Divider small />

      <Control.FileDropzone
        data-testid="fileDropzone"
        id="file"
        {...form.register('file', {
          required: validate.required(),
        })}
        accept={['video/*', 'audio/*']}
        maxVideoSize={BYTES_MAX_SIZE}
        maxAudioSize={BYTES_MAX_SIZE}
        caption={<DefaultCaption />}
        validationError={form.formState.errors.file?.message as string | undefined}
        supportedVideoTypes={SUPPORTED_VIDEO_MIME}
        supportedAudioTypes={SUPPORTED_AUDIO_MIME}
        supportedImageTypes={[]}
        supportedArchiveTypes={[]}
      />

      <Divider small />

      <div className={st.Actions}>
        <Control.Button
          data-testid="submitCheck"
          size="medium"
          type="submit"
          variant="filled"
        >
          {t('checks:check video audio.submit button')}
        </Control.Button>
        <Control.Button
          data-testid="cancel"
          kind="secondary"
          onClick={onCloseModal}
          size="medium"
          variant="outlined"
        >
          {t('shared:кнопка.отмена')}
        </Control.Button>
      </div>
    </form>
  );
};

export default VideoAndAudioForm;

